import { render, staticRenderFns } from "./MotorProposalRef.vue?vue&type=template&id=5b4a8fb8&"
import script from "./MotorProposalRef.vue?vue&type=script&lang=js&"
export * from "./MotorProposalRef.vue?vue&type=script&lang=js&"
import style0 from "./MotorProposalRef.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorProposalRef.vue"
export default component.exports